import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router'; // MVA - UPGRADE
import { Subscription } from 'rxjs';
import { EventManagerService } from './shared/event-manager.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Mortgagee Virtual Assistant'

  private updateViewSub:Subscription

  public constructor(
    private titleService: Title, 
    private eventManager: EventManagerService, 
    private changeDetector: ChangeDetectorRef) {
    this.titleService.setTitle( this.title )
  }

  ngOnInit() {
    this.updateViewSub = this.eventManager.getTopic('update-view-topic').subscribe(() => {
      console.log('Updating View Changes.')
      this.changeDetector.detectChanges()
    })
  }

  ngDestroy() {
    console.log('Destroying the App Component...')
    this.updateViewSub.unsubscribe()
  }
}
